import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { useRequiredContext } from "@redotech/react-util/context";
import MessageTextCircle02Icon from "@redotech/redo-icons/message-text-circle-02.svg";
import MessageTextCircle02IconFilled from "@redotech/redo-icons/message-text-circle-02_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";

export const TextConciergeItems = memo(function TextConciergeItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);

  const isEnabled = team.featureFlags?.[FeatureFlagKey.SHOPPER_AGENT] === true;

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.shopperAgentHref }}
      FilledIcon={MessageTextCircle02IconFilled}
      friendlyName="Text Concierge"
      hidden={!isEnabled}
      id="text-concierge"
      UnfilledIcon={MessageTextCircle02Icon}
    />
  );
});
